export const configURL = {
  url: "https://instagram-moc-server.onrender.com",
};
